"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jwPaginate = _interopRequireDefault(require("jw-paginate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TableFooter = function TableFooter(_ref) {
  var dataRowsLength = _ref.dataRowsLength,
    filteredDataRowsLength = _ref.filteredDataRowsLength,
    rowsPerPage = _ref.rowsPerPage,
    currentPage = _ref.currentPage,
    onChange = _ref.onChange,
    className = _ref.className;
  // Poor man’s error boundary
  if (filteredDataRowsLength > dataRowsLength) {
    return null;
  }
  var pagination = (0, _jwPaginate["default"])(filteredDataRowsLength, currentPage, rowsPerPage, 7);
  var restyledPages = pagination.pages;

  // A couple of edge cases where jw-paginate gets all wonky
  if (filteredDataRowsLength === 0) {
    restyledPages = [];
  } else if (rowsPerPage === 0) {
    restyledPages = [1];
    pagination.totalPages = 1;
  }

  // Replace first and last pages with 1 and n if they’re not visible in the default 7 items
  if (restyledPages[0] > 1) {
    restyledPages[0] = 1;
    restyledPages[1] = "\u2026";
  }
  if (restyledPages[restyledPages.length - 1] < pagination.totalPages) {
    restyledPages[restyledPages.length - 1] = pagination.totalPages;
    restyledPages[restyledPages.length - 2] = "\u2026";
  }
  var currentPageDataRowsLength = pagination.pageSize === 0 && pagination.totalPages === 1 ? "all" : pagination.endIndex - pagination.startIndex + 1;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, dataRowsLength === 0 ? "Nothing to see here. Move along!" : filteredDataRowsLength === 0 ? "Your query didn\u2019t match any experiments." : "Showing ".concat(currentPageDataRowsLength, " result").concat(currentPageDataRowsLength === "all" || currentPageDataRowsLength > 1 ? "s" : "", " ") + "".concat(filteredDataRowsLength < dataRowsLength ? " out of ".concat(filteredDataRowsLength, " ") : "") + "from a total of ".concat(dataRowsLength, " experiments") + "".concat(pagination.totalPages > 1 ? " (page ".concat(currentPage, " of ").concat(pagination.totalPages, ")") : "", ".")), /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "pagination",
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/_react["default"].createElement("li", null, filteredDataRowsLength === 0 || currentPage === 1 ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "disabled"
  }, "Previous") : /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return onChange(currentPage - 1);
    }
  }, "Previous")), restyledPages.map(function (pageIndicator, i) {
    return pageIndicator === "\u2026" ? /*#__PURE__*/_react["default"].createElement("li", {
      key: i,
      className: "disabled"
    }, pageIndicator) : pageIndicator === currentPage ? /*#__PURE__*/_react["default"].createElement("li", {
      key: i,
      className: "current"
    }, currentPage) : /*#__PURE__*/_react["default"].createElement("li", {
      key: i
    }, /*#__PURE__*/_react["default"].createElement("a", {
      onClick: function onClick() {
        return onChange(pageIndicator);
      }
    }, pageIndicator));
  }), /*#__PURE__*/_react["default"].createElement("li", null, filteredDataRowsLength === 0 || currentPage === pagination.totalPages ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "disabled"
  }, "Next") : /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return onChange(currentPage + 1);
    }
  }, "Next")))));
};
TableFooter.propTypes = {
  dataRowsLength: _propTypes["default"].number.isRequired,
  filteredDataRowsLength: _propTypes["default"].number.isRequired,
  rowsPerPage: _propTypes["default"].number.isRequired,
  currentPage: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string
};
TableFooter.defaultProps = {
  className: "small-6 columns padding-top-medium"
};
var _default = exports["default"] = TableFooter;